import { render, staticRenderFns } from "./BottomBarConfigurator.vue?vue&type=template&id=0cce54ec&scoped=true&"
import script from "./BottomBarConfigurator.vue?vue&type=script&lang=js&"
export * from "./BottomBarConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./BottomBarConfigurator.vue?vue&type=style&index=0&id=0cce54ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cce54ec",
  null
  
)

export default component.exports